/** Auth API route paths (relative to API base URL). */
export const authApiRoutes = Object.freeze({
  loginAuto: '/api/auth/login/auto',
  login: '/api/auth/login',
  verifyOtp: '/api/auth/login/otp',
})
